import "../../shared/assetDetailsButtons.css";
import PrintQRButton from "../../shared/PrintQRButton";
import React, { useEffect, useState } from "react";
import axios from "axios";
import "./comAssetDetails.css";
import { Link, useNavigate } from "react-router-dom";
import { downloadQRLabel } from "../../../utils/qrLabelPrint";
import useAutoRefresh from "../../../hooks/useAutoRefresh";
import useDebouncedValue from "../../../hooks/useDebouncedValue";
import AssetPagination from "../../shared/AssetPagination";

const ComAssetDetails = () => {
    const [assetRegisterDetails, setAssetRegisterDetails] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");
    const [searchQuery1, setSearchQuery1] = useState("");
    const [searchQuery2, setSearchQuery2] = useState("");
    const [categories, setCategories] = useState([]);
    const [currentUser, setCurrentUser] = useState(null);
    const [showDiscardModal, setShowDiscardModal] = useState(false);
    const [selectedAssetId, setSelectedAssetId] = useState(null);
    const [discardReason, setDiscardReason] = useState("");
    const [page, setPage] = useState(1);
    const [pagination, setPagination] = useState({ total: 0, totalPages: 1 });
    const serverSearch = useDebouncedValue([searchQuery, searchQuery1, searchQuery2].filter(Boolean).join(" "));
    useEffect(() => setPage(1), [serverSearch]);

    //const user = JSON.parse(localStorage.getItem("currentUser"));
    // State for editing
    const [editingAsset, setEditingAsset] = useState(null);

     const openDiscardModal = (id) => {
      setSelectedAssetId(id);
      setShowDiscardModal(true);
    };

    useEffect(() => {
        fetchCategories();
      }, []);


useEffect(() => {
    if (categories.length > 0) {
      fetchAssets();
    }
  }, [categories, page, serverSearch]);


     //Asset department Filter
       const fetchCategories = async () => {
         try {
           const response = await axios.get(
             "/api/categories/getCategory"
           );
           setCategories(response.data);
         } catch (error) {
           console.error("Error fetching categories:", error);
         }
       };



     // ---------------- FETCH ASSETS ----------------
  const fetchAssets = async () => {
    const storedUser = JSON.parse(localStorage.getItem("currentUser"));

    if (!storedUser || !storedUser.username) {
      console.error("User not found");
      return;
    }

    try {
      const userResponse = await axios.get(
        "/api/users/getallUsers"
      );

      const userData = userResponse.data.find(
        (user) => user.username === storedUser.username
      );

      if (!userData || !userData.companyName) {
        console.error("User company not found");
        return;
      }

      setCurrentUser(userData);

      const assetResponse = await axios.get(
        "/api/AssetRegisterDetails/getAssetDetails2",
        { params: { paginated: true, page, limit: 100, search: serverSearch, company: userData.companyName } }
      );

      // ✅ Show ALL company assets
      const companyAssets = assetResponse.data.assets.filter(
        (asset) => asset.company === userData.companyName
      );

      setAssetRegisterDetails(companyAssets);
      setPagination(assetResponse.data.pagination);
    } catch (error) {
      console.error("Error fetching assets:", error);
    }
  };

  useAutoRefresh(fetchAssets);
    
    
    

    const navigate = useNavigate();

    const handleTransferClick = (asset) => {
        navigate("/CompanyAssetTranfer", { state: { asset } }); // Pass asset data via state
    };


    // Update an existing asseta
    const handleUpdateAsset = (id, updatedAsset) => {
        axios.put(`/api/AssetRegisterDetails/updateAsset/${id}`, updatedAsset)
            .then(() => {
                fetchAssets();
                setEditingAsset(null);
            })
            .catch(error => console.error("Error updating asset:", error));
    };

 // Delete an asset
   const confirmDiscard = async () => {
   if (!discardReason.trim()) {
     alert("Discard reason is required!");
     return;
   }
 
   const assetToDelete = assetRegisterDetails.find(
     (asset) => asset._id === selectedAssetId
   );
 
   try {
     const assetWithReason = {
       ...assetToDelete,
       discardReason: discardReason,
       discardedDate: new Date(),
     };
 
     await axios.post(
       "/api/DeletedAssets/add",/* "/api/DeletedAssets/add",*/
       assetWithReason
     );
 
     await axios.delete(
       `/api/AssetRegisterDetails/deleteAsset/${selectedAssetId}`
       /*`/api/AssetRegisterDetails/deleteAsset/${selectedAssetId}`*/
     );
 
     fetchAssets();
     setShowDiscardModal(false);
     setDiscardReason("");
     alert("Asset discarded successfully!");
   } catch (error) {
     console.error("Error discarding asset:", error);
   }
 };



    const handleDownloadQR = async (asset) => {
    try {
      await downloadQRLabel(asset);
    } catch (error) {
      window.alert(error.message || "Unable to download the QR label.");
    }
  };


    // Filter logic
    const filteredAssets = assetRegisterDetails.filter(asset => {
        const queryMatch = (query, asset) =>
            (asset.name?.toLowerCase() || "").includes(query.toLowerCase()) ||
           
            (asset.department?.toLowerCase() || "").includes(query.toLowerCase()) ||
            (asset.category?.toLowerCase() || "").includes(query.toLowerCase()) ||
            (asset.type?.toLowerCase() || "").includes(query.toLowerCase()) ||
            (asset.assetName?.toLowerCase() || "").includes(query.toLowerCase()) ||
            (asset.assetUserName?.toLowerCase() || "").includes(query.toLowerCase()) ||
            (asset.assetModel?.toLowerCase() || "").includes(query.toLowerCase()) ||
            (asset.serialNumber?.toLowerCase() || "").includes(query.toLowerCase()) ||
             (asset.assetUpdateDate?.toLowerCase() || "").includes(query.toLowerCase()) ||
            (asset.assetTransferDate?.toLowerCase() || "").includes(query.toLowerCase()) ||
            (asset.trackingId?.toLowerCase() || "").includes(query.toLowerCase()) ||
            (asset.subComponent?.toLowerCase() || "").includes(query.toLowerCase())||
            (asset.conditionType?.toLowerCase() || "").includes(query.toLowerCase()) ||
            (asset.invoiceDetails?.toLowerCase() || "").includes(query.toLowerCase()) ||
            (asset.specialNote?.toLowerCase() || "").includes(query.toLowerCase()) ||
            (asset.warranty?.toLowerCase() || "").includes(query.toLowerCase()) ||
            (asset.supplierName?.toLowerCase() || "").includes(query.toLowerCase());

        return [searchQuery, searchQuery1, searchQuery2].every(query => !query || queryMatch(query, asset));
    });


// ---------------- PERMISSION LOGIC ----------------
 // ---------------- PERMISSION LOGIC ----------------
const canUserModifyAsset = (asset) => {
  if (!currentUser || !categories.length) return false;

  // 🔹 Special Rule for FF&E → Tables, Chairs, Cupboards
  if (
    asset.category ===
      "Furniture, Fixtures & Office Equipment (FF&E)" &&
    asset.type === "Tables, Chairs, Cupboards"
  ) {
    // ✅ Only same department can modify
    return asset.department === currentUser.department;
  }

  // 🔹 Default Category-Based Access (Your Existing Logic)
  const categoryData = categories.find(
    (cat) =>
      cat.category === asset.category &&
      cat.types === asset.type
  );

  if (!categoryData) return false;

  return categoryData.departments.includes(
    currentUser.department
  );
};

 const exportToExcel = () => {
  if (!filteredAssets || filteredAssets.length === 0) {
    alert("No filtered data available to export!");
    return;
  }

  const XLSX = require("xlsx");

  // REMOVE unwanted fields for each filtered asset
  const cleanedData = filteredAssets.map(
    ({
      _id,
     computerComponents,
      createdAt,
      updatedAt,
      __v,
      ...rest
    }) => rest
  );

  // Convert to worksheet
  const ws = XLSX.utils.json_to_sheet(cleanedData);

  // Auto column width
  const colWidths = Object.keys(cleanedData[0]).map((key) => ({
    wch: 20,
  }));
  ws['!cols'] = colWidths;

  // Create workbook
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Filtered Assets");

  // Export
  XLSX.writeFile(wb, "Filtered_Asset_Details.xlsx");
};



    return ( 
        <div className="row asset-details-buttons">
            <div className="col-md-14">
                <h1 className="assethead">Asset Details</h1>
                <p>
                    <Link to="/CompanyDashBord">DashBoard</Link> / <Link to="/Comasset">Asset Details</Link>
                </p>

<button className="btnExcel" onClick={exportToExcel}>
  Export Filtered Assets to Excel
</button>
                {/* Search Inputs */}<div className="row"><div className="col-md-4">
                    <input type="text" className="form-control mb-2" placeholder="Search..." value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)} />
                </div><div className="col-md-4"><input type="text" className="form-control mb-2" placeholder="Search by another parameter..." value={searchQuery1} onChange={(e) => setSearchQuery1(e.target.value)} />
                    </div><div className="col-md-4"><input type="text" className="form-control mb-2" placeholder="Search by another parameter..." value={searchQuery2} onChange={(e) => setSearchQuery2(e.target.value)} />
                    </div></div>
                {/* Asset Table */}
                 <table className="table table-bordered table-light custom_table">
          <thead>
            <tr>
              <th>Registered Name</th>
              <th>Company</th>
              <th>Department</th>
              <th>Category</th>
              <th>Condition Type</th>
              <th>Type</th>
              <th>Asset Name</th>
              <th>EPF No & Recipient Name</th>
              <th>Model</th>
              <th>Register Date</th>
              <th>Transfer Date</th>
              <th>Serial Number</th>
              <th>Tracking ID</th>
              <th>Price (Rs)</th>
              <th>Special Note</th>
              <th>Components</th>
              <th>Asset Image</th>
              <th>Invoice Image</th>
              <th>Warranty</th>
              <th>Supplier Name</th>
              <th>Invoice Number</th>
              <th>Purchase Date</th>
              
              <th>Actions</th>
            </tr>
          </thead>

          <tbody>
            {filteredAssets.map((asset) => (
              <tr key={asset._id}>
               <td>{asset.name}</td>
                      <td>{asset.company}</td>
                      <td>{asset.department}</td>
                      <td>{asset.category}</td>
                      <td>{asset.conditionType}</td>
                      <td>{asset.type}</td>
                      <td>{asset.assetName}</td>
                      <td>{asset.assetUserName}</td>
                      <td>{asset.assetModel}</td>
                      <td>
                        {asset.assetUpdateDate}

                      </td>
                      <td>{asset.assetTransferDate}</td>
                      <td>{asset.serialNumber}</td>
                      <td>{asset.trackingId}</td>
                      <td>{asset.assetprice}</td>
                      <td>{asset.specialNote}</td>
                     <td>{asset.subComponent}</td>
                    <td>
                      {asset.assetImageURL ? (
                        <a
                          href={asset.assetImageURL}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          View Image
                        </a>
                      ) : (
                        "No Image"
                      )}
                    </td>

                    <td>
                      {asset.invoiceFileURL ? (
                        <a
                          href={asset.invoiceFileURL}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          View Invoice
                        </a>
                      ) : (
                        "No Invoice"
                      )}
                    </td>
                      <td>{asset.warranty}</td>
                      <td>{asset.supplierName}</td>
                      <td>{asset.invoiceDetails}</td>
                      <td>{asset.purchaseDate}</td>

                <td className="d-flex gap-2">
                  {/* ✅ Category-based permission */}
                  {canUserModifyAsset(asset) && (
                    <>
                      <button
                        className="btn btn-primary1"
                        onClick={() =>
                          handleTransferClick(asset)
                        }
                      >
                        Transfer
                      </button>

                                                    <button
  className="btn btn-danger2"
  onClick={() => openDiscardModal(asset._id)}
>
  Discard
</button>
                    </>
                  )}

                  {/* QR always visible */}
                  <button
                    className="btn btn-success3"
                    onClick={() =>
                      handleDownloadQR(asset)
                    }
                  >
                    QR
                  </button>
                        <PrintQRButton asset={asset} />
                </td>
              </tr>
            ))}

            {filteredAssets.length === 0 && (
              <tr>
                <td
                  colSpan="6"
                  className="text-center"
                >
                  No matching asset data available
                </td>
              </tr>
            )}
          </tbody>
        </table>
        <AssetPagination page={pagination.page || page} totalPages={pagination.totalPages} total={pagination.total} onPageChange={setPage} />
      </div>


      {showDiscardModal && (
  <div className="discard-modal-overlay">
    <div className="discard-modal">
      <h3>Discard Asset</h3>
      <p>Please provide a reason for discarding this asset.</p>

      <textarea
        placeholder="Enter discard reason..."
        value={discardReason}
        onChange={(e) => setDiscardReason(e.target.value)}
      />

      <div className="modal-buttons">
        <button
          className="cancel-btn"
          onClick={() => setShowDiscardModal(false)}
        >
          Cancel
        </button>
        <button
          className="confirm-btn"
          onClick={confirmDiscard}
        >
          Confirm Discard
        </button>
      </div>
    </div>
  </div>
)}
    </div>
  );
};

export default ComAssetDetails;
